

export default rewriteExportAssignments;
import hasOwnProp from 'utils/hasOwnProp';
function rewriteExportAssignments(body, node, parent, exports, scope, capturedUpdates) {
	var assignee = undefined;

	if (node.type === 'AssignmentExpression') {
		assignee = node.left;
	} else if (node.type === 'UpdateExpression') {
		assignee = node.argument;
	} else {
		return; // not an assignment
	}

	if (assignee.type !== 'Identifier') {
		return;
	}

	var name = assignee.name;

	if (scope.contains(name, true)) {
		return; // shadows an export
	}

	if (exports && hasOwnProp.call(exports, name)) {
		var exportAs = exports[name];

		if (!!capturedUpdates) {
			capturedUpdates.push({ name: name, exportAs: exportAs });
			return;
		}

		// special case - increment/decrement operators
		if (node.operator === '++' || node.operator === '--') {
			var prefix = '';
			var suffix = ', exports.' + exportAs + ' = ' + name;
			if (parent.type !== 'ExpressionStatement') {
				if (!node.prefix) {
					suffix += ', ' + name + ' ' + (node.operator === '++' ? '-' : '+') + ' 1';
				}
				prefix += '( ';
				suffix += ' )';
			}
			body.insert(node.start, prefix);
			body.insert(node.end, suffix);
		} else {
			body.insert(node.start, 'exports.' + exportAs + ' = ');
		}
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/ast/rewriteExportAssignments.js.01-babel.map